import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-details-machine',
  templateUrl: './projects-details-machine.component.html',
  styleUrls: ['./projects-details-machine.component.scss']
})
export class ProjectsDetailsMachineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
